import {Participant, User} from "@twilio/conversations";

export class ChatMemberAndUser{

  member: Participant;
  user: User;
  typing = false;
}

